import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dashboard-shell" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "brand" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav-menu" }
const _hoisted_6 = { class: "sidebar-footer" }
const _hoisted_7 = {
  key: 0,
  class: "user-avatar user-avatar-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "user-avatar"
}
const _hoisted_10 = { class: "user-copy" }
const _hoisted_11 = { class: "fas fa-chevron-up user-chevron" }
const _hoisted_12 = {
  key: 0,
  class: "user-popover"
}
const _hoisted_13 = { class: "user-popover-item" }
const _hoisted_14 = { class: "user-popover-item" }
const _hoisted_15 = { class: "user-popover-item" }
const _hoisted_16 = { class: "footer-buttons" }
const _hoisted_17 = { class: "main-content" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "content-header" }
const _hoisted_20 = { class: "content-title-wrap" }
const _hoisted_21 = { class: "content-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", { active: !$setup.sidebarCollapsed }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args)))
    }, null, 2),
    _createElementVNode("nav", {
      class: _normalizeClass(["sidebar", { collapsed: $setup.sidebarCollapsed }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: $setup.sidebarLogoSrc,
            alt: "JMA Sysc",
            class: "brand-logo"
          }, null, 8, _hoisted_4)
        ], 512), [
          [_vShow, !$setup.sidebarCollapsed]
        ]),
        ($setup.sidebarCollapsed)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args))),
              class: "toggle-btn",
              "aria-label": "Abrir sidebar"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "nav-link",
            "exact-active-class": "active",
            onClick: $setup.closeSidebar
          }, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-home" }, null, -1)),
              _withDirectives(_createElementVNode("span", null, "Início", 512), [
                [_vShow, !$setup.sidebarCollapsed]
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/assistente",
            class: "nav-link",
            "active-class": "active",
            onClick: $setup.closeSidebar
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-robot" }, null, -1)),
              _withDirectives(_createElementVNode("span", null, "Assistente IA", 512), [
                [_vShow, !$setup.sidebarCollapsed]
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/dashboard/clientes",
            class: "nav-link",
            "active-class": "active",
            onClick: $setup.closeSidebar
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-users" }, null, -1)),
              _withDirectives(_createElementVNode("span", null, "Clientes", 512), [
                [_vShow, !$setup.sidebarCollapsed]
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/dashboard/honorarios",
            class: "nav-link",
            "active-class": "active",
            onClick: $setup.closeSidebar
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-money-bill-wave" }, null, -1)),
              _withDirectives(_createElementVNode("span", null, "Honorários", 512), [
                [_vShow, !$setup.sidebarCollapsed]
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/dashboard/perfil",
            class: "nav-link",
            "active-class": "active",
            onClick: $setup.closeSidebar
          }, {
            default: _withCtx(() => [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-user-cog" }, null, -1)),
              _withDirectives(_createElementVNode("span", null, "Perfil", 512), [
                [_vShow, !$setup.sidebarCollapsed]
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["user-panel", { open: $setup.userMenuOpen, compact: $setup.sidebarCollapsed }])
        }, [
          _createElementVNode("button", {
            class: "user-trigger",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.toggleUserMenu && $setup.toggleUserMenu(...args)))
          }, [
            ($setup.currentUser?.photoUrl || $setup.currentUser?.avatar)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("img", {
                    src: $setup.currentUser?.photoUrl || $setup.currentUser?.avatar || '',
                    alt: "Avatar do usuario"
                  }, null, 8, _hoisted_8)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.userInitials), 1)),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createElementVNode("strong", null, _toDisplayString($setup.userDisplayName), 1),
              _createElementVNode("span", null, _toDisplayString($setup.currentUser?.email || 'Sem email'), 1)
            ], 512), [
              [_vShow, !$setup.sidebarCollapsed]
            ]),
            _withDirectives(_createElementVNode("i", _hoisted_11, null, 512), [
              [_vShow, !$setup.sidebarCollapsed]
            ])
          ]),
          ($setup.userMenuOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "user-popover-title" }, "Conta", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "Email", -1)),
                  _createElementVNode("strong", null, _toDisplayString($setup.currentUser?.email || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "User", -1)),
                  _createElementVNode("strong", null, _toDisplayString($setup.currentUser?.displayName || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "User da empresa", -1)),
                  _createElementVNode("strong", null, _toDisplayString($setup.currentUser?.userId || '-'), 1)
                ]),
                _createElementVNode("button", {
                  class: "profile-shortcut",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goToProfile && $setup.goToProfile(...args)))
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "fas fa-user-cog" }, null, -1),
                  _createElementVNode("span", null, "Editar Perfil", -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.toggleTheme && $setup.toggleTheme(...args))),
            class: "theme-btn"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass($setup.isDarkTheme ? 'fas fa-sun' : 'fas fa-moon')
            }, null, 2),
            _withDirectives(_createElementVNode("span", null, "Tema", 512), [
              [_vShow, !$setup.sidebarCollapsed]
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
            class: "logout-btn"
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)),
            _withDirectives(_createElementVNode("span", null, "Sair", 512), [
              [_vShow, !$setup.sidebarCollapsed]
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("main", _hoisted_17, [
      _createElementVNode("img", {
        src: $setup.dashboardArtSrc,
        alt: "",
        class: "dashboard-art",
        "aria-hidden": "true"
      }, null, 8, _hoisted_18),
      _createElementVNode("header", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          ($setup.sidebarCollapsed)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "mobile-menu-btn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.toggleSidebar && $setup.toggleSidebar(...args))),
                "aria-label": "Abrir menu"
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "eyebrow" }, "Painel", -1)),
          _createElementVNode("h1", {
            class: _normalizeClass({ 'title-regular': $setup.isHonorariosTitle })
          }, _toDisplayString($setup.pageTitle), 3)
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}